//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import ClientBase from './clientBase'

export interface IClient {

  /**
   * Cet all buyersCards
   * @return OK
   */
  buyersCardsAll(): Promise<BuyersCard[]>;

  /**
   * add a new buyersCard
  if exists delete old and add new
   * @param body (optional)
   * @return Created
   */
  buyersCardsPOST(body: BuyersCard | undefined): Promise<BuyersCard>;

  /**
   * Cet all buyersCards
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_BuyersCards(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<BuyersCard[]>;

  /**
   * Cet all buyersCards
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_BuyersCards_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<BuyersCard[]>;

  /**
   * Get a buyersCard
   * @return OK
   */
  buyersCardsGET(key: number): Promise<BuyersCard>;

  /**
   * update a buyerscard
   * @param body (optional)
   * @return No Content
   */
  buyersCardsPUT(key: number, body: BuyersCard | undefined): Promise<void>;

  /**
   * delete a buyerscard
   * @return No Content
   */
  buyersCardsDELETE(id: number): Promise<void>;

  /**
   * @return OK
   */
  searchAvailableBuyerscards(from: number): Promise<number[]>;

  /**
   * Get all buyersCardViews
   * @return OK
   */
  buyersCardViewsAll(): Promise<BuyersCardView[]>;

  /**
   * Get all buyersCardViews
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_BuyersCardViews(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<BuyersCardView[]>;

  /**
   * Get all buyersCardViews
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_BuyersCardViews_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<BuyersCardView[]>;

  /**
   * Get a buyersCard
   * @return OK
   */
  buyersCardViews(key: number): Promise<BuyersCardView>;

  /**
   * Gets this instance.
   * @return OK
   */
  features(): Promise<Feature[]>;

  /**
   * Gets this instance.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Features(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Feature[]>;

  /**
   * Gets this instance.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Features_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Feature[]>;

  /**
   * Gets the FloridayUsers.
   * @return OK
   */
  floridayUsersAll(): Promise<FloridayUser[]>;

  /**
   * Gets the FloridayUsers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_FloridayUsers(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<FloridayUser[]>;

  /**
   * Gets the FloridayUsers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_FloridayUsers_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<FloridayUser[]>;

  /**
   * Gets the FloridayUser.
   * @param key The key.
   * @return OK
   */
  floridayUsers(key: string): Promise<FloridayUser>;

  /**
   * @return OK
   */
  byAlternateId(alternateId: string): Promise<FloridayUser[]>;

  /**
   * Gets the inkoperklok.
   * @param key The key.
   * @return OK
   */
  inkoperKlokken(key: number): Promise<InkoperKlok>;

  /**
   * Gets the inkopers.
   * @return OK
   */
  inkoperKlokkenAll(): Promise<InkoperKlok[]>;

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperKlokken(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperKlok[]>;

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperKlokken_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperKlok[]>;

  /**
   * Gets the inkoperklokViews from the inkoper.
   * @return OK
   */
  getFromInkoper(inkoperIdentificatie: string): Promise<InkoperKlokView[]>;

  /**
   * Gets the InkoperKlok view.
   * @param key The key.
   * @return OK
   */
  inkoperKlokViews(key: number): Promise<InkoperKlokView>;

  /**
   * Gets the koperplaten views.
   * @return OK
   */
  inkoperKlokViewsAll(): Promise<InkoperKlokView[]>;

  /**
   * Gets the koperplaten views.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperKlokViews(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperKlokView[]>;

  /**
   * Gets the koperplaten views.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperKlokViews_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperKlokView[]>;

  /**
   * Gets the inkoperklokken.
   * @return OK
   */
  getFromInkoper2(inkoperIdentificatie: string): Promise<InkoperKlokView[]>;

  /**
   * Updates the inkoperklokken.
   * @param body (optional)
   * @return Created
   */
  updateInkoperKlokken(body: UpdateInkoperKlokken | undefined): Promise<void>;

  /**
   * Gets the inkoperPlaat.
   * @param key The key.
   * @return OK
   */
  inkoperPlatenGET(key: number): Promise<InkoperPlaat>;

  /**
   * Deletes the InkoperPlaat.
   * @param key The key.
   */
  inkoperPlatenDELETE(key: number): Promise<void>;

  /**
   * Gets the inkopers.
   * @return OK
   */
  inkoperPlatenAll(): Promise<InkoperPlaat[]>;

  /**
   * Posts the inkoper
   * @param body (optional) The entity.
   * @return Created
   */
  inkoperPlatenPOST(body: InkoperPlaat | undefined): Promise<InkoperPlaat>;

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperPlaten(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperPlaat[]>;

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperPlaten_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperPlaat[]>;

  /**
   * Gets the inkopers.
   * @return OK
   */
  getFromInkoper3(inkoperIdentificatie: string): Promise<InkoperPlaat[]>;

  /**
   * Gets the inkoper.
   * @param key The key.
   * @return OK
   */
  inkopersGET(key: number): Promise<Inkoper>;

  /**
   * Deletes the Inkoper.
   * @param key The key.
   */
  inkopersDELETE(key: number): Promise<void>;

  /**
   * updates the inkoper
   * @param key The key.
   * @param body (optional) The entity.
   */
  inkopersPUT(key: number, body: Inkoper | undefined): Promise<void>;

  /**
   * Gets the inkopers.
   * @return OK
   */
  inkopersAll(): Promise<Inkoper[]>;

  /**
   * Posts the inkoper
   * @param body (optional) The entity.
   * @return Created
   */
  inkopersPOST(body: Inkoper | undefined): Promise<Inkoper>;

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Inkopers(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Inkoper[]>;

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Inkopers_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Inkoper[]>;

  /**
   * Migreer inkoper naar floriday
   * @param body (optional)
   * @return No Content
   */
  migratieInkoper(body: MigratieInkoper | undefined): Promise<void>;

  /**
   * Gets the koperplaat view.
   * @param key The key.
   * @return OK
   */
  inkoperViews(key: number): Promise<InkoperView>;

  /**
   * Gets the koperplaten views.
   * @return OK
   */
  inkoperViewsAll(): Promise<InkoperView[]>;

  /**
   * Gets the koperplaten views.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperViews(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperView[]>;

  /**
   * Gets the koperplaten views.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperViews_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperView[]>;

  /**
   * @return OK
   */
  klantLimieten(): Promise<KlantLimiet[]>;

  /**
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_KlantLimieten(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<KlantLimiet[]>;

  /**
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_KlantLimieten_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<KlantLimiet[]>;

  /**
   * Gets the koper.
   * @param key The key.
   * @return OK
   */
  kopers(key: number): Promise<void>;

  /**
   * Gets the kopers.
   * @return OK
   */
  kopers2(): Promise<void>;

  /**
   * Gets the kopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Kopers(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<void>;

  /**
   * Gets the kopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Kopers_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<void>;

  /**
   * Gets the locatie.
   * @param key The key.
   * @return OK
   */
  locaties(key: string): Promise<Locatie>;

  /**
   * Gets the locaties.
   * @return OK
   */
  locatiesAll(): Promise<Locatie[]>;

  /**
   * Gets the locaties.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Locaties(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Locatie[]>;

  /**
   * Gets the locaties.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Locaties_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Locatie[]>;

  /**
   * Get all user account limits
   * @return OK
   */
  userAccountDayLimitsAll(): Promise<UserAccountDayLimit[]>;

  /**
   * Add a useraccountdaylimit
   * @param body (optional) Fh.Rru.VeilcontractBeheerService.Application.Interfaces.Model.UserAccountDayLimit
   * @return Created
   */
  userAccountDayLimitsPOST(body: UserAccountDayLimit | undefined): Promise<UserAccountDayLimit>;

  /**
   * Get all user account limits
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_UserAccountDayLimits(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<UserAccountDayLimit[]>;

  /**
   * Get all user account limits
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_UserAccountDayLimits_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<UserAccountDayLimit[]>;

  /**
   * get a single useracountlimit
   * @return OK
   */
  userAccountDayLimitsGET(key: number): Promise<UserAccountDayLimit>;

  /**
   * @return No Content
   */
  userAccountDayLimitsDELETE(key: number): Promise<void>;

  /**
   * @return OK
   */
  history(useraccountName: string): Promise<UserAccountDayLimit[]>;

  /**
   * Get all user account limits
   * @return OK
   */
  userAccountDayLimitViewsAll(): Promise<UserAccountDayLimitView[]>;

  /**
   * Get all user account limits
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_UserAccountDayLimitViews(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<UserAccountDayLimitView[]>;

  /**
   * Get all user account limits
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_UserAccountDayLimitViews_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<UserAccountDayLimitView[]>;

  /**
   * get a single useracountlimit
   * @return OK
   */
  userAccountDayLimitViews(key: number): Promise<UserAccountDayLimit>;
}

export class Client extends ClientBase implements IClient {
  protected http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
      super();
      this.http = http ? http : window as any;
      this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  /**
   * Cet all buyersCards
   * @return OK
   */
  buyersCardsAll(): Promise<BuyersCard[]> {
      let url_ = this.baseUrl + "/api/v1/BuyersCards";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBuyersCardsAll(_response));
      });
  }

  protected processBuyersCardsAll(response: Response): Promise<BuyersCard[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(BuyersCard.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BuyersCard[]>(null as any);
  }

  /**
   * add a new buyersCard
  if exists delete old and add new
   * @param body (optional)
   * @return Created
   */
  buyersCardsPOST(body: BuyersCard | undefined): Promise<BuyersCard> {
      let url_ = this.baseUrl + "/api/v1/BuyersCards";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBuyersCardsPOST(_response));
      });
  }

  protected processBuyersCardsPOST(response: Response): Promise<BuyersCard> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result201 = BuyersCard.fromJS(resultData201);
          return result201;
          });
      } else if (status === 400) {
          return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException("Bad Request", status, _responseText, _headers, result400);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BuyersCard>(null as any);
  }

  /**
   * Cet all buyersCards
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_BuyersCards(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<BuyersCard[]> {
      let url_ = this.baseUrl + "/odata/v1/BuyersCards?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_BuyersCards(_response));
      });
  }

  protected processOdata_v1_BuyersCards(response: Response): Promise<BuyersCard[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(BuyersCard.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BuyersCard[]>(null as any);
  }

  /**
   * Cet all buyersCards
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_BuyersCards_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<BuyersCard[]> {
      let url_ = this.baseUrl + "/odata/v1/BuyersCards/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_BuyersCards_$count(_response));
      });
  }

  protected processOdata_v1_BuyersCards_$count(response: Response): Promise<BuyersCard[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(BuyersCard.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BuyersCard[]>(null as any);
  }

  /**
   * Get a buyersCard
   * @return OK
   */
  buyersCardsGET(key: number): Promise<BuyersCard> {
      let url_ = this.baseUrl + "/api/v1/BuyersCards/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBuyersCardsGET(_response));
      });
  }

  protected processBuyersCardsGET(response: Response): Promise<BuyersCard> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BuyersCard.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BuyersCard>(null as any);
  }

  /**
   * update a buyerscard
   * @param body (optional)
   * @return No Content
   */
  buyersCardsPUT(key: number, body: BuyersCard | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/v1/BuyersCards/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBuyersCardsPUT(_response));
      });
  }

  protected processBuyersCardsPUT(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 400) {
          return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException("Bad Request", status, _responseText, _headers, result400);
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * delete a buyerscard
   * @return No Content
   */
  buyersCardsDELETE(id: number): Promise<void> {
      let url_ = this.baseUrl + "/api/v1/BuyersCards/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBuyersCardsDELETE(_response));
      });
  }

  protected processBuyersCardsDELETE(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 400) {
          return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException("Bad Request", status, _responseText, _headers, result400);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  searchAvailableBuyerscards(from: number): Promise<number[]> {
      let url_ = this.baseUrl + "/api/v1/BuyersCards/searchAvailableBuyerscards/{from}";
      if (from === undefined || from === null)
          throw new Error("The parameter 'from' must be defined.");
      url_ = url_.replace("{from}", encodeURIComponent("" + from));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processSearchAvailableBuyerscards(_response));
      });
  }

  protected processSearchAvailableBuyerscards(response: Response): Promise<number[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(item);
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number[]>(null as any);
  }

  /**
   * Get all buyersCardViews
   * @return OK
   */
  buyersCardViewsAll(): Promise<BuyersCardView[]> {
      let url_ = this.baseUrl + "/api/v1/BuyersCardViews";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBuyersCardViewsAll(_response));
      });
  }

  protected processBuyersCardViewsAll(response: Response): Promise<BuyersCardView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(BuyersCardView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BuyersCardView[]>(null as any);
  }

  /**
   * Get all buyersCardViews
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_BuyersCardViews(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<BuyersCardView[]> {
      let url_ = this.baseUrl + "/odata/v1/BuyersCardViews?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_BuyersCardViews(_response));
      });
  }

  protected processOdata_v1_BuyersCardViews(response: Response): Promise<BuyersCardView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(BuyersCardView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BuyersCardView[]>(null as any);
  }

  /**
   * Get all buyersCardViews
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_BuyersCardViews_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<BuyersCardView[]> {
      let url_ = this.baseUrl + "/odata/v1/BuyersCardViews/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_BuyersCardViews_$count(_response));
      });
  }

  protected processOdata_v1_BuyersCardViews_$count(response: Response): Promise<BuyersCardView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(BuyersCardView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BuyersCardView[]>(null as any);
  }

  /**
   * Get a buyersCard
   * @return OK
   */
  buyersCardViews(key: number): Promise<BuyersCardView> {
      let url_ = this.baseUrl + "/api/v1/BuyersCardViews/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBuyersCardViews(_response));
      });
  }

  protected processBuyersCardViews(response: Response): Promise<BuyersCardView> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BuyersCardView.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BuyersCardView>(null as any);
  }

  /**
   * Gets this instance.
   * @return OK
   */
  features(): Promise<Feature[]> {
      let url_ = this.baseUrl + "/api/v1/Features";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFeatures(_response));
      });
  }

  protected processFeatures(response: Response): Promise<Feature[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(Feature.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Feature[]>(null as any);
  }

  /**
   * Gets this instance.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Features(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Feature[]> {
      let url_ = this.baseUrl + "/odata/v1/Features?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_Features(_response));
      });
  }

  protected processOdata_v1_Features(response: Response): Promise<Feature[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(Feature.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Feature[]>(null as any);
  }

  /**
   * Gets this instance.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Features_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Feature[]> {
      let url_ = this.baseUrl + "/odata/v1/Features/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_Features_$count(_response));
      });
  }

  protected processOdata_v1_Features_$count(response: Response): Promise<Feature[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(Feature.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Feature[]>(null as any);
  }

  /**
   * Gets the FloridayUsers.
   * @return OK
   */
  floridayUsersAll(): Promise<FloridayUser[]> {
      let url_ = this.baseUrl + "/api/v1/FloridayUsers";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFloridayUsersAll(_response));
      });
  }

  protected processFloridayUsersAll(response: Response): Promise<FloridayUser[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FloridayUser.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FloridayUser[]>(null as any);
  }

  /**
   * Gets the FloridayUsers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_FloridayUsers(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<FloridayUser[]> {
      let url_ = this.baseUrl + "/odata/v1/FloridayUsers?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_FloridayUsers(_response));
      });
  }

  protected processOdata_v1_FloridayUsers(response: Response): Promise<FloridayUser[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FloridayUser.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FloridayUser[]>(null as any);
  }

  /**
   * Gets the FloridayUsers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_FloridayUsers_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<FloridayUser[]> {
      let url_ = this.baseUrl + "/odata/v1/FloridayUsers/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_FloridayUsers_$count(_response));
      });
  }

  protected processOdata_v1_FloridayUsers_$count(response: Response): Promise<FloridayUser[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FloridayUser.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FloridayUser[]>(null as any);
  }

  /**
   * Gets the FloridayUser.
   * @param key The key.
   * @return OK
   */
  floridayUsers(key: string): Promise<FloridayUser> {
      let url_ = this.baseUrl + "/api/v1/FloridayUsers/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFloridayUsers(_response));
      });
  }

  protected processFloridayUsers(response: Response): Promise<FloridayUser> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FloridayUser.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FloridayUser>(null as any);
  }

  /**
   * @return OK
   */
  byAlternateId(alternateId: string): Promise<FloridayUser[]> {
      let url_ = this.baseUrl + "/api/v1/FloridayUsers/ByAlternateId/{alternateId}";
      if (alternateId === undefined || alternateId === null)
          throw new Error("The parameter 'alternateId' must be defined.");
      url_ = url_.replace("{alternateId}", encodeURIComponent("" + alternateId));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processByAlternateId(_response));
      });
  }

  protected processByAlternateId(response: Response): Promise<FloridayUser[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FloridayUser.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = IActionResult.fromJS(resultData404);
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          resultdefault = ProblemDetails.fromJS(resultDatadefault);
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * Gets the inkoperklok.
   * @param key The key.
   * @return OK
   */
  inkoperKlokken(key: number): Promise<InkoperKlok> {
      let url_ = this.baseUrl + "/api/v1/InkoperKlokken/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkoperKlokken(_response));
      });
  }

  protected processInkoperKlokken(response: Response): Promise<InkoperKlok> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = InkoperKlok.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperKlok>(null as any);
  }

  /**
   * Gets the inkopers.
   * @return OK
   */
  inkoperKlokkenAll(): Promise<InkoperKlok[]> {
      let url_ = this.baseUrl + "/api/v1/InkoperKlokken";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkoperKlokkenAll(_response));
      });
  }

  protected processInkoperKlokkenAll(response: Response): Promise<InkoperKlok[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperKlok.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperKlok[]>(null as any);
  }

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperKlokken(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperKlok[]> {
      let url_ = this.baseUrl + "/odata/v1/InkoperKlokken?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_InkoperKlokken(_response));
      });
  }

  protected processOdata_v1_InkoperKlokken(response: Response): Promise<InkoperKlok[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperKlok.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperKlok[]>(null as any);
  }

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperKlokken_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperKlok[]> {
      let url_ = this.baseUrl + "/odata/v1/InkoperKlokken/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_InkoperKlokken_$count(_response));
      });
  }

  protected processOdata_v1_InkoperKlokken_$count(response: Response): Promise<InkoperKlok[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperKlok.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperKlok[]>(null as any);
  }

  /**
   * Gets the inkoperklokViews from the inkoper.
   * @return OK
   */
  getFromInkoper(inkoperIdentificatie: string): Promise<InkoperKlokView[]> {
      let url_ = this.baseUrl + "/api/v1/InkoperKlokken/GetFromInkoper/{inkoperIdentificatie}";
      if (inkoperIdentificatie === undefined || inkoperIdentificatie === null)
          throw new Error("The parameter 'inkoperIdentificatie' must be defined.");
      url_ = url_.replace("{inkoperIdentificatie}", encodeURIComponent("" + inkoperIdentificatie));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGetFromInkoper(_response));
      });
  }

  protected processGetFromInkoper(response: Response): Promise<InkoperKlokView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperKlokView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperKlokView[]>(null as any);
  }

  /**
   * Gets the InkoperKlok view.
   * @param key The key.
   * @return OK
   */
  inkoperKlokViews(key: number): Promise<InkoperKlokView> {
      let url_ = this.baseUrl + "/api/v1/InkoperKlokViews/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkoperKlokViews(_response));
      });
  }

  protected processInkoperKlokViews(response: Response): Promise<InkoperKlokView> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = InkoperKlokView.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperKlokView>(null as any);
  }

  /**
   * Gets the koperplaten views.
   * @return OK
   */
  inkoperKlokViewsAll(): Promise<InkoperKlokView[]> {
      let url_ = this.baseUrl + "/api/v1/InkoperKlokViews";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkoperKlokViewsAll(_response));
      });
  }

  protected processInkoperKlokViewsAll(response: Response): Promise<InkoperKlokView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperKlokView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperKlokView[]>(null as any);
  }

  /**
   * Gets the koperplaten views.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperKlokViews(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperKlokView[]> {
      let url_ = this.baseUrl + "/odata/v1/InkoperKlokViews?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_InkoperKlokViews(_response));
      });
  }

  protected processOdata_v1_InkoperKlokViews(response: Response): Promise<InkoperKlokView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperKlokView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperKlokView[]>(null as any);
  }

  /**
   * Gets the koperplaten views.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperKlokViews_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperKlokView[]> {
      let url_ = this.baseUrl + "/odata/v1/InkoperKlokViews/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_InkoperKlokViews_$count(_response));
      });
  }

  protected processOdata_v1_InkoperKlokViews_$count(response: Response): Promise<InkoperKlokView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperKlokView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperKlokView[]>(null as any);
  }

  /**
   * Gets the inkoperklokken.
   * @return OK
   */
  getFromInkoper2(inkoperIdentificatie: string): Promise<InkoperKlokView[]> {
      let url_ = this.baseUrl + "/api/v1/InkoperKlokViews/GetFromInkoper/{inkoperIdentificatie}";
      if (inkoperIdentificatie === undefined || inkoperIdentificatie === null)
          throw new Error("The parameter 'inkoperIdentificatie' must be defined.");
      url_ = url_.replace("{inkoperIdentificatie}", encodeURIComponent("" + inkoperIdentificatie));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGetFromInkoper2(_response));
      });
  }

  protected processGetFromInkoper2(response: Response): Promise<InkoperKlokView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperKlokView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperKlokView[]>(null as any);
  }

  /**
   * Updates the inkoperklokken.
   * @param body (optional)
   * @return Created
   */
  updateInkoperKlokken(body: UpdateInkoperKlokken | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/v1/InkoperKlokViews/UpdateInkoperKlokken";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processUpdateInkoperKlokken(_response));
      });
  }

  protected processUpdateInkoperKlokken(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * Gets the inkoperPlaat.
   * @param key The key.
   * @return OK
   */
  inkoperPlatenGET(key: number): Promise<InkoperPlaat> {
      let url_ = this.baseUrl + "/api/v1/InkoperPlaten/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkoperPlatenGET(_response));
      });
  }

  protected processInkoperPlatenGET(response: Response): Promise<InkoperPlaat> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = InkoperPlaat.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperPlaat>(null as any);
  }

  /**
   * Deletes the InkoperPlaat.
   * @param key The key.
   */
  inkoperPlatenDELETE(key: number): Promise<void> {
      let url_ = this.baseUrl + "/api/v1/InkoperPlaten/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkoperPlatenDELETE(_response));
      });
  }

  protected processInkoperPlatenDELETE(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * Gets the inkopers.
   * @return OK
   */
  inkoperPlatenAll(): Promise<InkoperPlaat[]> {
      let url_ = this.baseUrl + "/api/v1/InkoperPlaten";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkoperPlatenAll(_response));
      });
  }

  protected processInkoperPlatenAll(response: Response): Promise<InkoperPlaat[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperPlaat.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperPlaat[]>(null as any);
  }

  /**
   * Posts the inkoper
   * @param body (optional) The entity.
   * @return Created
   */
  inkoperPlatenPOST(body: InkoperPlaat | undefined): Promise<InkoperPlaat> {
      let url_ = this.baseUrl + "/api/v1/InkoperPlaten";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkoperPlatenPOST(_response));
      });
  }

  protected processInkoperPlatenPOST(response: Response): Promise<InkoperPlaat> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result201 = InkoperPlaat.fromJS(resultData201);
          return result201;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperPlaat>(null as any);
  }

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperPlaten(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperPlaat[]> {
      let url_ = this.baseUrl + "/odata/v1/InkoperPlaten?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_InkoperPlaten(_response));
      });
  }

  protected processOdata_v1_InkoperPlaten(response: Response): Promise<InkoperPlaat[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperPlaat.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperPlaat[]>(null as any);
  }

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperPlaten_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperPlaat[]> {
      let url_ = this.baseUrl + "/odata/v1/InkoperPlaten/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_InkoperPlaten_$count(_response));
      });
  }

  protected processOdata_v1_InkoperPlaten_$count(response: Response): Promise<InkoperPlaat[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperPlaat.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperPlaat[]>(null as any);
  }

  /**
   * Gets the inkopers.
   * @return OK
   */
  getFromInkoper3(inkoperIdentificatie: string): Promise<InkoperPlaat[]> {
      let url_ = this.baseUrl + "/api/v1/InkoperPlaten/GetFromInkoper/{inkoperIdentificatie}";
      if (inkoperIdentificatie === undefined || inkoperIdentificatie === null)
          throw new Error("The parameter 'inkoperIdentificatie' must be defined.");
      url_ = url_.replace("{inkoperIdentificatie}", encodeURIComponent("" + inkoperIdentificatie));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGetFromInkoper3(_response));
      });
  }

  protected processGetFromInkoper3(response: Response): Promise<InkoperPlaat[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperPlaat.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperPlaat[]>(null as any);
  }

  /**
   * Gets the inkoper.
   * @param key The key.
   * @return OK
   */
  inkopersGET(key: number): Promise<Inkoper> {
      let url_ = this.baseUrl + "/api/v1/Inkopers/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkopersGET(_response));
      });
  }

  protected processInkopersGET(response: Response): Promise<Inkoper> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Inkoper.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Inkoper>(null as any);
  }

  /**
   * Deletes the Inkoper.
   * @param key The key.
   */
  inkopersDELETE(key: number): Promise<void> {
      let url_ = this.baseUrl + "/api/v1/Inkopers/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkopersDELETE(_response));
      });
  }

  protected processInkopersDELETE(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * updates the inkoper
   * @param key The key.
   * @param body (optional) The entity.
   */
  inkopersPUT(key: number, body: Inkoper | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/v1/Inkopers/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkopersPUT(_response));
      });
  }

  protected processInkopersPUT(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * Gets the inkopers.
   * @return OK
   */
  inkopersAll(): Promise<Inkoper[]> {
      let url_ = this.baseUrl + "/api/v1/Inkopers";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkopersAll(_response));
      });
  }

  protected processInkopersAll(response: Response): Promise<Inkoper[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(Inkoper.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Inkoper[]>(null as any);
  }

  /**
   * Posts the inkoper
   * @param body (optional) The entity.
   * @return Created
   */
  inkopersPOST(body: Inkoper | undefined): Promise<Inkoper> {
      let url_ = this.baseUrl + "/api/v1/Inkopers";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkopersPOST(_response));
      });
  }

  protected processInkopersPOST(response: Response): Promise<Inkoper> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result201 = Inkoper.fromJS(resultData201);
          return result201;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Inkoper>(null as any);
  }

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Inkopers(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Inkoper[]> {
      let url_ = this.baseUrl + "/odata/v1/Inkopers?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_Inkopers(_response));
      });
  }

  protected processOdata_v1_Inkopers(response: Response): Promise<Inkoper[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(Inkoper.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Inkoper[]>(null as any);
  }

  /**
   * Gets the inkopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Inkopers_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Inkoper[]> {
      let url_ = this.baseUrl + "/odata/v1/Inkopers/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_Inkopers_$count(_response));
      });
  }

  protected processOdata_v1_Inkopers_$count(response: Response): Promise<Inkoper[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(Inkoper.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Inkoper[]>(null as any);
  }

  /**
   * Migreer inkoper naar floriday
   * @param body (optional)
   * @return No Content
   */
  migratieInkoper(body: MigratieInkoper | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/v1/Inkopers/migratieInkoper";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMigratieInkoper(_response));
      });
  }

  protected processMigratieInkoper(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * Gets the koperplaat view.
   * @param key The key.
   * @return OK
   */
  inkoperViews(key: number): Promise<InkoperView> {
      let url_ = this.baseUrl + "/api/v1/InkoperViews/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkoperViews(_response));
      });
  }

  protected processInkoperViews(response: Response): Promise<InkoperView> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = InkoperView.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperView>(null as any);
  }

  /**
   * Gets the koperplaten views.
   * @return OK
   */
  inkoperViewsAll(): Promise<InkoperView[]> {
      let url_ = this.baseUrl + "/api/v1/InkoperViews";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processInkoperViewsAll(_response));
      });
  }

  protected processInkoperViewsAll(response: Response): Promise<InkoperView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperView[]>(null as any);
  }

  /**
   * Gets the koperplaten views.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperViews(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperView[]> {
      let url_ = this.baseUrl + "/odata/v1/InkoperViews?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_InkoperViews(_response));
      });
  }

  protected processOdata_v1_InkoperViews(response: Response): Promise<InkoperView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperView[]>(null as any);
  }

  /**
   * Gets the koperplaten views.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_InkoperViews_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<InkoperView[]> {
      let url_ = this.baseUrl + "/odata/v1/InkoperViews/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_InkoperViews_$count(_response));
      });
  }

  protected processOdata_v1_InkoperViews_$count(response: Response): Promise<InkoperView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(InkoperView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<InkoperView[]>(null as any);
  }

  /**
   * @return OK
   */
  klantLimieten(): Promise<KlantLimiet[]> {
      let url_ = this.baseUrl + "/api/v1/KlantLimieten";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processKlantLimieten(_response));
      });
  }

  protected processKlantLimieten(response: Response): Promise<KlantLimiet[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(KlantLimiet.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<KlantLimiet[]>(null as any);
  }

  /**
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_KlantLimieten(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<KlantLimiet[]> {
      let url_ = this.baseUrl + "/odata/v1/KlantLimieten?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_KlantLimieten(_response));
      });
  }

  protected processOdata_v1_KlantLimieten(response: Response): Promise<KlantLimiet[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(KlantLimiet.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<KlantLimiet[]>(null as any);
  }

  /**
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_KlantLimieten_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<KlantLimiet[]> {
      let url_ = this.baseUrl + "/odata/v1/KlantLimieten/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_KlantLimieten_$count(_response));
      });
  }

  protected processOdata_v1_KlantLimieten_$count(response: Response): Promise<KlantLimiet[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(KlantLimiet.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<KlantLimiet[]>(null as any);
  }

  /**
   * Gets the koper.
   * @param key The key.
   * @return OK
   */
  kopers(key: number): Promise<void> {
      let url_ = this.baseUrl + "/api/v1/Kopers/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processKopers(_response));
      });
  }

  protected processKopers(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * Gets the kopers.
   * @return OK
   */
  kopers2(): Promise<void> {
      let url_ = this.baseUrl + "/api/v1/Kopers";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processKopers2(_response));
      });
  }

  protected processKopers2(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * Gets the kopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Kopers(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<void> {
      let url_ = this.baseUrl + "/odata/v1/Kopers?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_Kopers(_response));
      });
  }

  protected processOdata_v1_Kopers(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * Gets the kopers.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Kopers_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<void> {
      let url_ = this.baseUrl + "/odata/v1/Kopers/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_Kopers_$count(_response));
      });
  }

  protected processOdata_v1_Kopers_$count(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * Gets the locatie.
   * @param key The key.
   * @return OK
   */
  locaties(key: string): Promise<Locatie> {
      let url_ = this.baseUrl + "/api/v1/Locaties/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processLocaties(_response));
      });
  }

  protected processLocaties(response: Response): Promise<Locatie> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Locatie.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Locatie>(null as any);
  }

  /**
   * Gets the locaties.
   * @return OK
   */
  locatiesAll(): Promise<Locatie[]> {
      let url_ = this.baseUrl + "/api/v1/Locaties";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processLocatiesAll(_response));
      });
  }

  protected processLocatiesAll(response: Response): Promise<Locatie[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(Locatie.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Locatie[]>(null as any);
  }

  /**
   * Gets the locaties.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Locaties(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Locatie[]> {
      let url_ = this.baseUrl + "/odata/v1/Locaties?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_Locaties(_response));
      });
  }

  protected processOdata_v1_Locaties(response: Response): Promise<Locatie[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(Locatie.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Locatie[]>(null as any);
  }

  /**
   * Gets the locaties.
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_Locaties_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<Locatie[]> {
      let url_ = this.baseUrl + "/odata/v1/Locaties/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_Locaties_$count(_response));
      });
  }

  protected processOdata_v1_Locaties_$count(response: Response): Promise<Locatie[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(Locatie.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<Locatie[]>(null as any);
  }

  /**
   * Get all user account limits
   * @return OK
   */
  userAccountDayLimitsAll(): Promise<UserAccountDayLimit[]> {
      let url_ = this.baseUrl + "/api/v1/UserAccountDayLimits";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processUserAccountDayLimitsAll(_response));
      });
  }

  protected processUserAccountDayLimitsAll(response: Response): Promise<UserAccountDayLimit[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(UserAccountDayLimit.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<UserAccountDayLimit[]>(null as any);
  }

  /**
   * Add a useraccountdaylimit
   * @param body (optional) Fh.Rru.VeilcontractBeheerService.Application.Interfaces.Model.UserAccountDayLimit
   * @return Created
   */
  userAccountDayLimitsPOST(body: UserAccountDayLimit | undefined): Promise<UserAccountDayLimit> {
      let url_ = this.baseUrl + "/api/v1/UserAccountDayLimits";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processUserAccountDayLimitsPOST(_response));
      });
  }

  protected processUserAccountDayLimitsPOST(response: Response): Promise<UserAccountDayLimit> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result201 = UserAccountDayLimit.fromJS(resultData201);
          return result201;
          });
      } else if (status === 400) {
          return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException("Bad Request", status, _responseText, _headers, result400);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<UserAccountDayLimit>(null as any);
  }

  /**
   * Get all user account limits
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_UserAccountDayLimits(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<UserAccountDayLimit[]> {
      let url_ = this.baseUrl + "/odata/v1/UserAccountDayLimits?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_UserAccountDayLimits(_response));
      });
  }

  protected processOdata_v1_UserAccountDayLimits(response: Response): Promise<UserAccountDayLimit[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(UserAccountDayLimit.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<UserAccountDayLimit[]>(null as any);
  }

  /**
   * Get all user account limits
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_UserAccountDayLimits_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<UserAccountDayLimit[]> {
      let url_ = this.baseUrl + "/odata/v1/UserAccountDayLimits/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_UserAccountDayLimits_$count(_response));
      });
  }

  protected processOdata_v1_UserAccountDayLimits_$count(response: Response): Promise<UserAccountDayLimit[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(UserAccountDayLimit.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<UserAccountDayLimit[]>(null as any);
  }

  /**
   * get a single useracountlimit
   * @return OK
   */
  userAccountDayLimitsGET(key: number): Promise<UserAccountDayLimit> {
      let url_ = this.baseUrl + "/api/v1/UserAccountDayLimits/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processUserAccountDayLimitsGET(_response));
      });
  }

  protected processUserAccountDayLimitsGET(response: Response): Promise<UserAccountDayLimit> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserAccountDayLimit.fromJS(resultData200);
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<UserAccountDayLimit>(null as any);
  }

  /**
   * @return No Content
   */
  userAccountDayLimitsDELETE(key: number): Promise<void> {
      let url_ = this.baseUrl + "/api/v1/UserAccountDayLimits/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processUserAccountDayLimitsDELETE(_response));
      });
  }

  protected processUserAccountDayLimitsDELETE(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 400) {
          return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException("Bad Request", status, _responseText, _headers, result400);
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  history(useraccountName: string): Promise<UserAccountDayLimit[]> {
      let url_ = this.baseUrl + "/api/v1/UserAccountDayLimits/history/{useraccountName}";
      if (useraccountName === undefined || useraccountName === null)
          throw new Error("The parameter 'useraccountName' must be defined.");
      url_ = url_.replace("{useraccountName}", encodeURIComponent("" + useraccountName));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processHistory(_response));
      });
  }

  protected processHistory(response: Response): Promise<UserAccountDayLimit[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 401) {
          return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException("Unauthorized", status, _responseText, _headers, result401);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException("Forbidden", status, _responseText, _headers, result403);
          });
      } else if (status === 405) {
          return response.text().then((_responseText) => {
          let result405: any = null;
          let resultData405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result405 = ProblemDetails.fromJS(resultData405);
          return throwException("Method Not Allowed", status, _responseText, _headers, result405);
          });
      } else if (status === 500) {
          return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException("Internal Server Error", status, _responseText, _headers, result500);
          });
      } else if (status === 502) {
          return response.text().then((_responseText) => {
          return throwException("Bad Gateway", status, _responseText, _headers);
          });
      } else if (status === 503) {
          return response.text().then((_responseText) => {
          return throwException("Service Unavailable", status, _responseText, _headers);
          });
      } else if (status === 504) {
          return response.text().then((_responseText) => {
          return throwException("Gateway Timeout", status, _responseText, _headers);
          });
      } else if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(UserAccountDayLimit.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<UserAccountDayLimit[]>(null as any);
  }

  /**
   * Get all user account limits
   * @return OK
   */
  userAccountDayLimitViewsAll(): Promise<UserAccountDayLimitView[]> {
      let url_ = this.baseUrl + "/api/v1/UserAccountDayLimitViews";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processUserAccountDayLimitViewsAll(_response));
      });
  }

  protected processUserAccountDayLimitViewsAll(response: Response): Promise<UserAccountDayLimitView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(UserAccountDayLimitView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<UserAccountDayLimitView[]>(null as any);
  }

  /**
   * Get all user account limits
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_UserAccountDayLimitViews(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<UserAccountDayLimitView[]> {
      let url_ = this.baseUrl + "/odata/v1/UserAccountDayLimitViews?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_UserAccountDayLimitViews(_response));
      });
  }

  protected processOdata_v1_UserAccountDayLimitViews(response: Response): Promise<UserAccountDayLimitView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(UserAccountDayLimitView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<UserAccountDayLimitView[]>(null as any);
  }

  /**
   * Get all user account limits
   * @param filter (optional) Filter the results using OData syntax.
   * @param orderby (optional) Order the results using OData syntax.
   * @param top (optional) Limit the number of results returned.
   * @param skip (optional) Skip the number of results returned.
   * @param count (optional) Count the number of results returned.
   * @param expand (optional) Expand the results using OData syntax.
   * @return OK
   */
  odata_v1_UserAccountDayLimitViews_$count(filter: any | undefined, orderby: any | undefined, top: any | undefined, skip: any | undefined, count: any | undefined, expand: any | undefined): Promise<UserAccountDayLimitView[]> {
      let url_ = this.baseUrl + "/odata/v1/UserAccountDayLimitViews/$count?";
      if (filter === null)
          throw new Error("The parameter 'filter' cannot be null.");
      else if (filter !== undefined)
          url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
      if (orderby === null)
          throw new Error("The parameter 'orderby' cannot be null.");
      else if (orderby !== undefined)
          url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
      if (top === null)
          throw new Error("The parameter 'top' cannot be null.");
      else if (top !== undefined)
          url_ += "$top=" + encodeURIComponent("" + top) + "&";
      if (skip === null)
          throw new Error("The parameter 'skip' cannot be null.");
      else if (skip !== undefined)
          url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
      if (count === null)
          throw new Error("The parameter 'count' cannot be null.");
      else if (count !== undefined)
          url_ += "$count=" + encodeURIComponent("" + count) + "&";
      if (expand === null)
          throw new Error("The parameter 'expand' cannot be null.");
      else if (expand !== undefined)
          url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOdata_v1_UserAccountDayLimitViews_$count(_response));
      });
  }

  protected processOdata_v1_UserAccountDayLimitViews_$count(response: Response): Promise<UserAccountDayLimitView[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(UserAccountDayLimitView.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<UserAccountDayLimitView[]>(null as any);
  }

  /**
   * get a single useracountlimit
   * @return OK
   */
  userAccountDayLimitViews(key: number): Promise<UserAccountDayLimit> {
      let url_ = this.baseUrl + "/api/v1/UserAccountDayLimitViews/{key}";
      if (key === undefined || key === null)
          throw new Error("The parameter 'key' must be defined.");
      url_ = url_.replace("{key}", encodeURIComponent("" + key));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processUserAccountDayLimitViews(_response));
      });
  }

  protected processUserAccountDayLimitViews(response: Response): Promise<UserAccountDayLimit> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserAccountDayLimit.fromJS(resultData200);
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<UserAccountDayLimit>(null as any);
  }
}

export class BuyersCard implements IBuyersCard {
  buyersCardId?: number;
  customerRfhRelationId?: number;
  aalsmeer?: boolean;
  naaldwijk?: boolean;
  rijnsburg?: boolean;
  eelde?: boolean;
  blockedindication?: boolean;
  releasedDateTime?: Date | undefined;
  remark?: string | undefined;
  creationDateTime?: Date;
  creationUser?: string | undefined;
  mutationDateTime?: Date;
  mutationUser?: string | undefined;
  startDate?: Date;
  endDate?: Date;
  blockedDateTime?: Date | undefined;
  isVervallen?: boolean;

  constructor(data?: IBuyersCard) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.buyersCardId = _data["buyersCardId"];
          this.customerRfhRelationId = _data["customerRfhRelationId"];
          this.aalsmeer = _data["aalsmeer"];
          this.naaldwijk = _data["naaldwijk"];
          this.rijnsburg = _data["rijnsburg"];
          this.eelde = _data["eelde"];
          this.blockedindication = _data["blockedindication"];
          this.releasedDateTime = _data["releasedDateTime"] ? new Date(_data["releasedDateTime"].toString()) : <any>undefined;
          this.remark = _data["remark"];
          this.creationDateTime = _data["creationDateTime"] ? new Date(_data["creationDateTime"].toString()) : <any>undefined;
          this.creationUser = _data["creationUser"];
          this.mutationDateTime = _data["mutationDateTime"] ? new Date(_data["mutationDateTime"].toString()) : <any>undefined;
          this.mutationUser = _data["mutationUser"];
          this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
          this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
          this.blockedDateTime = _data["blockedDateTime"] ? new Date(_data["blockedDateTime"].toString()) : <any>undefined;
          this.isVervallen = _data["isVervallen"];
      }
  }

  static fromJS(data: any): BuyersCard {
      data = typeof data === 'object' ? data : {};
      let result = new BuyersCard();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["buyersCardId"] = this.buyersCardId;
      data["customerRfhRelationId"] = this.customerRfhRelationId;
      data["aalsmeer"] = this.aalsmeer;
      data["naaldwijk"] = this.naaldwijk;
      data["rijnsburg"] = this.rijnsburg;
      data["eelde"] = this.eelde;
      data["blockedindication"] = this.blockedindication;
      data["releasedDateTime"] = this.releasedDateTime ? this.releasedDateTime.toISOString() : <any>undefined;
      data["remark"] = this.remark;
      data["creationDateTime"] = this.creationDateTime ? this.creationDateTime.toISOString() : <any>undefined;
      data["creationUser"] = this.creationUser;
      data["mutationDateTime"] = this.mutationDateTime ? this.mutationDateTime.toISOString() : <any>undefined;
      data["mutationUser"] = this.mutationUser;
      data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
      data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
      data["blockedDateTime"] = this.blockedDateTime ? this.blockedDateTime.toISOString() : <any>undefined;
      data["isVervallen"] = this.isVervallen;
      return data;
  }

  clone(): BuyersCard {
      const json = this.toJSON();
      let result = new BuyersCard();
      result.init(json);
      return result;
  }
}

export interface IBuyersCard {
  buyersCardId?: number;
  customerRfhRelationId?: number;
  aalsmeer?: boolean;
  naaldwijk?: boolean;
  rijnsburg?: boolean;
  eelde?: boolean;
  blockedindication?: boolean;
  releasedDateTime?: Date | undefined;
  remark?: string | undefined;
  creationDateTime?: Date;
  creationUser?: string | undefined;
  mutationDateTime?: Date;
  mutationUser?: string | undefined;
  startDate?: Date;
  endDate?: Date;
  blockedDateTime?: Date | undefined;
  isVervallen?: boolean;
}

export class BuyersCardView implements IBuyersCardView {
  buyersCardId?: number;
  customerRfhRelationId?: number;
  aalsmeer?: boolean;
  naaldwijk?: boolean;
  rijnsburg?: boolean;
  eelde?: boolean;
  blockedindication?: boolean;
  releasedDateTime?: Date | undefined;
  remark?: string | undefined;
  creationDateTime?: Date;
  creationUser?: string | undefined;
  mutationDateTime?: Date;
  mutationUser?: string | undefined;
  startDate?: Date;
  endDate?: Date;
  blockedDateTime?: Date | undefined;
  isVervallen?: boolean;
  customrRfhRelationName?: string | undefined;

  constructor(data?: IBuyersCardView) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.buyersCardId = _data["buyersCardId"];
          this.customerRfhRelationId = _data["customerRfhRelationId"];
          this.aalsmeer = _data["aalsmeer"];
          this.naaldwijk = _data["naaldwijk"];
          this.rijnsburg = _data["rijnsburg"];
          this.eelde = _data["eelde"];
          this.blockedindication = _data["blockedindication"];
          this.releasedDateTime = _data["releasedDateTime"] ? new Date(_data["releasedDateTime"].toString()) : <any>undefined;
          this.remark = _data["remark"];
          this.creationDateTime = _data["creationDateTime"] ? new Date(_data["creationDateTime"].toString()) : <any>undefined;
          this.creationUser = _data["creationUser"];
          this.mutationDateTime = _data["mutationDateTime"] ? new Date(_data["mutationDateTime"].toString()) : <any>undefined;
          this.mutationUser = _data["mutationUser"];
          this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
          this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
          this.blockedDateTime = _data["blockedDateTime"] ? new Date(_data["blockedDateTime"].toString()) : <any>undefined;
          this.isVervallen = _data["isVervallen"];
          this.customrRfhRelationName = _data["customrRfhRelationName"];
      }
  }

  static fromJS(data: any): BuyersCardView {
      data = typeof data === 'object' ? data : {};
      let result = new BuyersCardView();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["buyersCardId"] = this.buyersCardId;
      data["customerRfhRelationId"] = this.customerRfhRelationId;
      data["aalsmeer"] = this.aalsmeer;
      data["naaldwijk"] = this.naaldwijk;
      data["rijnsburg"] = this.rijnsburg;
      data["eelde"] = this.eelde;
      data["blockedindication"] = this.blockedindication;
      data["releasedDateTime"] = this.releasedDateTime ? this.releasedDateTime.toISOString() : <any>undefined;
      data["remark"] = this.remark;
      data["creationDateTime"] = this.creationDateTime ? this.creationDateTime.toISOString() : <any>undefined;
      data["creationUser"] = this.creationUser;
      data["mutationDateTime"] = this.mutationDateTime ? this.mutationDateTime.toISOString() : <any>undefined;
      data["mutationUser"] = this.mutationUser;
      data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
      data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
      data["blockedDateTime"] = this.blockedDateTime ? this.blockedDateTime.toISOString() : <any>undefined;
      data["isVervallen"] = this.isVervallen;
      data["customrRfhRelationName"] = this.customrRfhRelationName;
      return data;
  }

  clone(): BuyersCardView {
      const json = this.toJSON();
      let result = new BuyersCardView();
      result.init(json);
      return result;
  }
}

export interface IBuyersCardView {
  buyersCardId?: number;
  customerRfhRelationId?: number;
  aalsmeer?: boolean;
  naaldwijk?: boolean;
  rijnsburg?: boolean;
  eelde?: boolean;
  blockedindication?: boolean;
  releasedDateTime?: Date | undefined;
  remark?: string | undefined;
  creationDateTime?: Date;
  creationUser?: string | undefined;
  mutationDateTime?: Date;
  mutationUser?: string | undefined;
  startDate?: Date;
  endDate?: Date;
  blockedDateTime?: Date | undefined;
  isVervallen?: boolean;
  customrRfhRelationName?: string | undefined;
}

export class Feature implements IFeature {
  description?: string | undefined;
  isEnabled?: boolean;
  readonly key?: string | undefined;

  constructor(data?: IFeature) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.description = _data["description"];
          this.isEnabled = _data["isEnabled"];
          (<any>this).key = _data["key"];
      }
  }

  static fromJS(data: any): Feature {
      data = typeof data === 'object' ? data : {};
      let result = new Feature();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["description"] = this.description;
      data["isEnabled"] = this.isEnabled;
      data["key"] = this.key;
      return data;
  }

  clone(): Feature {
      const json = this.toJSON();
      let result = new Feature();
      result.init(json);
      return result;
  }
}

export interface IFeature {
  description?: string | undefined;
  isEnabled?: boolean;
  key?: string | undefined;
}

export class FloridayUser implements IFloridayUser {
  technicalId!: string;
  alternateId!: string;
  displayName!: string;
  status!: string;
  organizationId!: string;
  organizationGln!: string;
  inkoper?: Inkoper;
  koper?: Koper;

  constructor(data?: IFloridayUser) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.technicalId = _data["technicalId"];
          this.alternateId = _data["alternateId"];
          this.displayName = _data["displayName"];
          this.status = _data["status"];
          this.organizationId = _data["organizationId"];
          this.organizationGln = _data["organizationGln"];
          this.inkoper = _data["inkoper"] ? Inkoper.fromJS(_data["inkoper"]) : <any>undefined;
          this.koper = _data["koper"] ? Koper.fromJS(_data["koper"]) : <any>undefined;
      }
  }

  static fromJS(data: any): FloridayUser {
      data = typeof data === 'object' ? data : {};
      let result = new FloridayUser();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["technicalId"] = this.technicalId;
      data["alternateId"] = this.alternateId;
      data["displayName"] = this.displayName;
      data["status"] = this.status;
      data["organizationId"] = this.organizationId;
      data["organizationGln"] = this.organizationGln;
      data["inkoper"] = this.inkoper ? this.inkoper.toJSON() : <any>undefined;
      data["koper"] = this.koper ? this.koper.toJSON() : <any>undefined;
      return data;
  }

  clone(): FloridayUser {
      const json = this.toJSON();
      let result = new FloridayUser();
      result.init(json);
      return result;
  }
}

export interface IFloridayUser {
  technicalId: string;
  alternateId: string;
  displayName: string;
  status: string;
  organizationId: string;
  organizationGln: string;
  inkoper?: Inkoper;
  koper?: Koper;
}

export class IActionResult implements IIActionResult {

  constructor(data?: IIActionResult) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
  }

  static fromJS(data: any): IActionResult {
      data = typeof data === 'object' ? data : {};
      let result = new IActionResult();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
  }

  clone(): IActionResult {
      const json = this.toJSON();
      let result = new IActionResult();
      result.init(json);
      return result;
  }
}

export interface IIActionResult {
}

export class Inkoper implements IInkoper {
  /** Gets or sets the InkoperID. */
  inkoperID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  /** Gets or sets the Wachtwoord. */
  wachtwoord?: string | undefined;
  /** Gets or sets the KoperNummer. */
  koperNummer?: number;
  /** Gets or sets the AanmaakDatumTijd. */
  aanmaakDatumTijd?: Date;
  /** Gets or sets the AanmaakGebruiker. */
  aanmaakGebruiker?: string | undefined;
  /** Gets or sets the blokkeerindicatie. */
  blokkeerIndicatie?: boolean;
  /** Gets or sets the LocatieCode. */
  locatieCode?: string | undefined;
  /** Gets or sets the MutatieGebruiker. */
  mutatieGebruiker?: string | undefined;
  /** Gets or sets the MutatieDatumTijd. */
  mutatieDatumTijd?: Date;
  /** Gets or sets the VervallenDatumTijd. */
  vervallenDatumTijd?: Date;
  /** Gets or sets IsVervallen */
  isVervallen?: boolean;
  /** Gets or sets the Zetelnummer. */
  zetelnummer?: number | undefined;
  /** Gets or sets the BlokkerenDatumTijd. */
  blokkerenDatumTijd?: Date | undefined;
  /** Gets or sets the VrijgaveDatumTijd. */
  vrijgaveDatumTijd?: Date | undefined;
  /** Gets or sets the BlokkeerRedenCode. */
  blokkeerRedenCode?: number | undefined;
  /** Gets or sets the Opmerking. */
  opmerking?: string | undefined;
  /** Gets or sets the source */
  sourceCode?: string | undefined;
  /** Gets or sets the alias */
  alias?: string | undefined;
  /** Gets or sets the InkoperPlaten. */
  inkoperPlaten?: InkoperPlaat[] | undefined;

  constructor(data?: IInkoper) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.inkoperID = _data["inkoperID"];
          this.inkoperIdentificatie = _data["inkoperIdentificatie"];
          this.wachtwoord = _data["wachtwoord"];
          this.koperNummer = _data["koperNummer"];
          this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
          this.aanmaakGebruiker = _data["aanmaakGebruiker"];
          this.blokkeerIndicatie = _data["blokkeerIndicatie"];
          this.locatieCode = _data["locatieCode"];
          this.mutatieGebruiker = _data["mutatieGebruiker"];
          this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
          this.vervallenDatumTijd = _data["vervallenDatumTijd"] ? new Date(_data["vervallenDatumTijd"].toString()) : <any>undefined;
          this.isVervallen = _data["isVervallen"];
          this.zetelnummer = _data["zetelnummer"];
          this.blokkerenDatumTijd = _data["blokkerenDatumTijd"] ? new Date(_data["blokkerenDatumTijd"].toString()) : <any>undefined;
          this.vrijgaveDatumTijd = _data["vrijgaveDatumTijd"] ? new Date(_data["vrijgaveDatumTijd"].toString()) : <any>undefined;
          this.blokkeerRedenCode = _data["blokkeerRedenCode"];
          this.opmerking = _data["opmerking"];
          this.sourceCode = _data["sourceCode"];
          this.alias = _data["alias"];
          if (Array.isArray(_data["inkoperPlaten"])) {
              this.inkoperPlaten = [] as any;
              for (let item of _data["inkoperPlaten"])
                  this.inkoperPlaten!.push(InkoperPlaat.fromJS(item));
          }
      }
  }

  static fromJS(data: any): Inkoper {
      data = typeof data === 'object' ? data : {};
      let result = new Inkoper();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["inkoperID"] = this.inkoperID;
      data["inkoperIdentificatie"] = this.inkoperIdentificatie;
      data["wachtwoord"] = this.wachtwoord;
      data["koperNummer"] = this.koperNummer;
      data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
      data["aanmaakGebruiker"] = this.aanmaakGebruiker;
      data["blokkeerIndicatie"] = this.blokkeerIndicatie;
      data["locatieCode"] = this.locatieCode;
      data["mutatieGebruiker"] = this.mutatieGebruiker;
      data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
      data["vervallenDatumTijd"] = this.vervallenDatumTijd ? this.vervallenDatumTijd.toISOString() : <any>undefined;
      data["isVervallen"] = this.isVervallen;
      data["zetelnummer"] = this.zetelnummer;
      data["blokkerenDatumTijd"] = this.blokkerenDatumTijd ? this.blokkerenDatumTijd.toISOString() : <any>undefined;
      data["vrijgaveDatumTijd"] = this.vrijgaveDatumTijd ? this.vrijgaveDatumTijd.toISOString() : <any>undefined;
      data["blokkeerRedenCode"] = this.blokkeerRedenCode;
      data["opmerking"] = this.opmerking;
      data["sourceCode"] = this.sourceCode;
      data["alias"] = this.alias;
      if (Array.isArray(this.inkoperPlaten)) {
          data["inkoperPlaten"] = [];
          for (let item of this.inkoperPlaten)
              data["inkoperPlaten"].push(item.toJSON());
      }
      return data;
  }

  clone(): Inkoper {
      const json = this.toJSON();
      let result = new Inkoper();
      result.init(json);
      return result;
  }
}

export interface IInkoper {
  /** Gets or sets the InkoperID. */
  inkoperID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  /** Gets or sets the Wachtwoord. */
  wachtwoord?: string | undefined;
  /** Gets or sets the KoperNummer. */
  koperNummer?: number;
  /** Gets or sets the AanmaakDatumTijd. */
  aanmaakDatumTijd?: Date;
  /** Gets or sets the AanmaakGebruiker. */
  aanmaakGebruiker?: string | undefined;
  /** Gets or sets the blokkeerindicatie. */
  blokkeerIndicatie?: boolean;
  /** Gets or sets the LocatieCode. */
  locatieCode?: string | undefined;
  /** Gets or sets the MutatieGebruiker. */
  mutatieGebruiker?: string | undefined;
  /** Gets or sets the MutatieDatumTijd. */
  mutatieDatumTijd?: Date;
  /** Gets or sets the VervallenDatumTijd. */
  vervallenDatumTijd?: Date;
  /** Gets or sets IsVervallen */
  isVervallen?: boolean;
  /** Gets or sets the Zetelnummer. */
  zetelnummer?: number | undefined;
  /** Gets or sets the BlokkerenDatumTijd. */
  blokkerenDatumTijd?: Date | undefined;
  /** Gets or sets the VrijgaveDatumTijd. */
  vrijgaveDatumTijd?: Date | undefined;
  /** Gets or sets the BlokkeerRedenCode. */
  blokkeerRedenCode?: number | undefined;
  /** Gets or sets the Opmerking. */
  opmerking?: string | undefined;
  /** Gets or sets the source */
  sourceCode?: string | undefined;
  /** Gets or sets the alias */
  alias?: string | undefined;
  /** Gets or sets the InkoperPlaten. */
  inkoperPlaten?: InkoperPlaat[] | undefined;
}

export class InkoperKlok implements IInkoperKlok {
  /** Gets or sets the InkoperKlokID. */
  inkoperKlokID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  klokNummer?: number;
  mutatieGebruiker?: string | undefined;
  /** Gets or sets the MutatieDatumTijd. */
  mutatieDatumTijd?: Date;

  constructor(data?: IInkoperKlok) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.inkoperKlokID = _data["inkoperKlokID"];
          this.inkoperIdentificatie = _data["inkoperIdentificatie"];
          this.klokNummer = _data["klokNummer"];
          this.mutatieGebruiker = _data["mutatieGebruiker"];
          this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
      }
  }

  static fromJS(data: any): InkoperKlok {
      data = typeof data === 'object' ? data : {};
      let result = new InkoperKlok();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["inkoperKlokID"] = this.inkoperKlokID;
      data["inkoperIdentificatie"] = this.inkoperIdentificatie;
      data["klokNummer"] = this.klokNummer;
      data["mutatieGebruiker"] = this.mutatieGebruiker;
      data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
      return data;
  }

  clone(): InkoperKlok {
      const json = this.toJSON();
      let result = new InkoperKlok();
      result.init(json);
      return result;
  }
}

export interface IInkoperKlok {
  /** Gets or sets the InkoperKlokID. */
  inkoperKlokID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  klokNummer?: number;
  mutatieGebruiker?: string | undefined;
  /** Gets or sets the MutatieDatumTijd. */
  mutatieDatumTijd?: Date;
}

export class InkoperKlokView implements IInkoperKlokView {
  /** Gets or sets the InkoperKlokID. */
  inkoperKlokID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  klokNummer?: number;
  /** Gets or sets the KlokKorteNaam. */
  klokKorteNaam?: string | undefined;
  /** Gets or sets the KlokSoort. */
  klokSoort?: string | undefined;
  /** Gets or sets the Actief. */
  actief?: boolean;
  /** Gets or sets the ActiefOrgineel. */
  actiefOrgineel?: boolean;

  constructor(data?: IInkoperKlokView) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.inkoperKlokID = _data["inkoperKlokID"];
          this.inkoperIdentificatie = _data["inkoperIdentificatie"];
          this.klokNummer = _data["klokNummer"];
          this.klokKorteNaam = _data["klokKorteNaam"];
          this.klokSoort = _data["klokSoort"];
          this.actief = _data["actief"];
          this.actiefOrgineel = _data["actiefOrgineel"];
      }
  }

  static fromJS(data: any): InkoperKlokView {
      data = typeof data === 'object' ? data : {};
      let result = new InkoperKlokView();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["inkoperKlokID"] = this.inkoperKlokID;
      data["inkoperIdentificatie"] = this.inkoperIdentificatie;
      data["klokNummer"] = this.klokNummer;
      data["klokKorteNaam"] = this.klokKorteNaam;
      data["klokSoort"] = this.klokSoort;
      data["actief"] = this.actief;
      data["actiefOrgineel"] = this.actiefOrgineel;
      return data;
  }

  clone(): InkoperKlokView {
      const json = this.toJSON();
      let result = new InkoperKlokView();
      result.init(json);
      return result;
  }
}

export interface IInkoperKlokView {
  /** Gets or sets the InkoperKlokID. */
  inkoperKlokID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  klokNummer?: number;
  /** Gets or sets the KlokKorteNaam. */
  klokKorteNaam?: string | undefined;
  /** Gets or sets the KlokSoort. */
  klokSoort?: string | undefined;
  /** Gets or sets the Actief. */
  actief?: boolean;
  /** Gets or sets the ActiefOrgineel. */
  actiefOrgineel?: boolean;
}

export class InkoperPlaat implements IInkoperPlaat {
  /** Gets or sets the InkoperPlaatID. */
  inkoperPlaatID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  koperPlaatNummer?: number;
  mutatieGebruiker?: string | undefined;
  /** Gets or sets the MutatieDatumTijd. */
  mutatieDatumTijd?: Date;
  vestigingCode?: Vestiging;

  constructor(data?: IInkoperPlaat) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.inkoperPlaatID = _data["inkoperPlaatID"];
          this.inkoperIdentificatie = _data["inkoperIdentificatie"];
          this.koperPlaatNummer = _data["koperPlaatNummer"];
          this.mutatieGebruiker = _data["mutatieGebruiker"];
          this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
          this.vestigingCode = _data["vestigingCode"];
      }
  }

  static fromJS(data: any): InkoperPlaat {
      data = typeof data === 'object' ? data : {};
      let result = new InkoperPlaat();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["inkoperPlaatID"] = this.inkoperPlaatID;
      data["inkoperIdentificatie"] = this.inkoperIdentificatie;
      data["koperPlaatNummer"] = this.koperPlaatNummer;
      data["mutatieGebruiker"] = this.mutatieGebruiker;
      data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
      data["vestigingCode"] = this.vestigingCode;
      return data;
  }

  clone(): InkoperPlaat {
      const json = this.toJSON();
      let result = new InkoperPlaat();
      result.init(json);
      return result;
  }
}

export interface IInkoperPlaat {
  /** Gets or sets the InkoperPlaatID. */
  inkoperPlaatID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  koperPlaatNummer?: number;
  mutatieGebruiker?: string | undefined;
  /** Gets or sets the MutatieDatumTijd. */
  mutatieDatumTijd?: Date;
  vestigingCode?: Vestiging;
}

export class InkoperPlaatView implements IInkoperPlaatView {
  /** Gets or sets the InkoperPlaatID. */
  inkoperPlaatID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  koperPlaatNummer?: number;
  mutatieGebruiker?: string | undefined;
  /** Gets or sets the MutatieDatumTijd. */
  mutatieDatumTijd?: Date;
  vestigingCode?: Vestiging;

  constructor(data?: IInkoperPlaatView) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.inkoperPlaatID = _data["inkoperPlaatID"];
          this.inkoperIdentificatie = _data["inkoperIdentificatie"];
          this.koperPlaatNummer = _data["koperPlaatNummer"];
          this.mutatieGebruiker = _data["mutatieGebruiker"];
          this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
          this.vestigingCode = _data["vestigingCode"];
      }
  }

  static fromJS(data: any): InkoperPlaatView {
      data = typeof data === 'object' ? data : {};
      let result = new InkoperPlaatView();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["inkoperPlaatID"] = this.inkoperPlaatID;
      data["inkoperIdentificatie"] = this.inkoperIdentificatie;
      data["koperPlaatNummer"] = this.koperPlaatNummer;
      data["mutatieGebruiker"] = this.mutatieGebruiker;
      data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
      data["vestigingCode"] = this.vestigingCode;
      return data;
  }

  clone(): InkoperPlaatView {
      const json = this.toJSON();
      let result = new InkoperPlaatView();
      result.init(json);
      return result;
  }
}

export interface IInkoperPlaatView {
  /** Gets or sets the InkoperPlaatID. */
  inkoperPlaatID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  koperPlaatNummer?: number;
  mutatieGebruiker?: string | undefined;
  /** Gets or sets the MutatieDatumTijd. */
  mutatieDatumTijd?: Date;
  vestigingCode?: Vestiging;
}

export class InkoperView implements IInkoperView {
  /** Gets or sets the InkoperID. */
  inkoperID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  /** Gets or sets the Wachtwoord. */
  wachtwoord?: string | undefined;
  /** Gets or sets the KoperNummer. */
  koperNummer?: number;
  /** Gets or sets the AanmaakDatumTijd. */
  aanmaakDatumTijd?: Date;
  /** Gets or sets the AanmaakGebruiker. */
  aanmaakGebruiker?: string | undefined;
  /** Gets or sets the blokkeerindicatie. */
  blokkeerIndicatie?: boolean;
  /** Gets or sets the LocatieCode. */
  locatieCode?: string | undefined;
  /** Gets or sets the MutatieGebruiker. */
  mutatieGebruiker?: string | undefined;
  /** Gets or sets the MutatieDatumTijd. */
  mutatieDatumTijd?: Date;
  /** Gets or sets the VervallenDatumTijd. */
  vervallenDatumTijd?: Date;
  /** Is this User Account expired? */
  isVervallen?: boolean;
  /** Gets or sets the Zetelnummer. */
  zetelnummer?: number | undefined;
  /** Gets or sets the BlokkerenDatumTijd. */
  blokkerenDatumTijd?: Date | undefined;
  /** Gets or sets the VrijgaveDatumTijd. */
  vrijgaveDatumTijd?: Date | undefined;
  /** Gets or sets the BlokkeerRedenCode. */
  blokkeerRedenCode?: number | undefined;
  /** Gets or sets the Opmerking. */
  opmerking?: string | undefined;
  /** Gets or sets the KoperNaam. */
  koperNaam?: string | undefined;
  /** Gets or sets the LocatieOmschrijving. */
  locatieOmschrijving?: string | undefined;
  /** Gets or sets the BlokkeerRedenOmschrijving. */
  blokkeerRedenOmschrijving?: string | undefined;
  /** Gets or sets the BlokkeerRedenAutomatisch. */
  blokkeerRedenAutomatisch?: boolean | undefined;
  /** Gets or sets the source */
  sourceCode?: string | undefined;
  /** Gets or sets the alias */
  alias?: string | undefined;
  /** Gets or sets the InkoperPlaten. */
  inkoperPlaten?: InkoperPlaatView[] | undefined;
  /** Gets or sets InkoperPlatenLijst (t.b.v. filteren op frontend). */
  inkoperPlatenLijst?: string | undefined;
  /** de Inkoperlimiet */
  inkoperLimiet?: number | undefined;
  /** id van de inkoperlimiet */
  inkoperLimietId?: number | undefined;
  /** eind datum van de inkoperlimiet */
  limietEindDatum?: Date | undefined;

  constructor(data?: IInkoperView) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.inkoperID = _data["inkoperID"];
          this.inkoperIdentificatie = _data["inkoperIdentificatie"];
          this.wachtwoord = _data["wachtwoord"];
          this.koperNummer = _data["koperNummer"];
          this.aanmaakDatumTijd = _data["aanmaakDatumTijd"] ? new Date(_data["aanmaakDatumTijd"].toString()) : <any>undefined;
          this.aanmaakGebruiker = _data["aanmaakGebruiker"];
          this.blokkeerIndicatie = _data["blokkeerIndicatie"];
          this.locatieCode = _data["locatieCode"];
          this.mutatieGebruiker = _data["mutatieGebruiker"];
          this.mutatieDatumTijd = _data["mutatieDatumTijd"] ? new Date(_data["mutatieDatumTijd"].toString()) : <any>undefined;
          this.vervallenDatumTijd = _data["vervallenDatumTijd"] ? new Date(_data["vervallenDatumTijd"].toString()) : <any>undefined;
          this.isVervallen = _data["isVervallen"];
          this.zetelnummer = _data["zetelnummer"];
          this.blokkerenDatumTijd = _data["blokkerenDatumTijd"] ? new Date(_data["blokkerenDatumTijd"].toString()) : <any>undefined;
          this.vrijgaveDatumTijd = _data["vrijgaveDatumTijd"] ? new Date(_data["vrijgaveDatumTijd"].toString()) : <any>undefined;
          this.blokkeerRedenCode = _data["blokkeerRedenCode"];
          this.opmerking = _data["opmerking"];
          this.koperNaam = _data["koperNaam"];
          this.locatieOmschrijving = _data["locatieOmschrijving"];
          this.blokkeerRedenOmschrijving = _data["blokkeerRedenOmschrijving"];
          this.blokkeerRedenAutomatisch = _data["blokkeerRedenAutomatisch"];
          this.sourceCode = _data["sourceCode"];
          this.alias = _data["alias"];
          if (Array.isArray(_data["inkoperPlaten"])) {
              this.inkoperPlaten = [] as any;
              for (let item of _data["inkoperPlaten"])
                  this.inkoperPlaten!.push(InkoperPlaatView.fromJS(item));
          }
          this.inkoperPlatenLijst = _data["inkoperPlatenLijst"];
          this.inkoperLimiet = _data["inkoperLimiet"];
          this.inkoperLimietId = _data["inkoperLimietId"];
          this.limietEindDatum = _data["limietEindDatum"] ? new Date(_data["limietEindDatum"].toString()) : <any>undefined;
      }
  }

  static fromJS(data: any): InkoperView {
      data = typeof data === 'object' ? data : {};
      let result = new InkoperView();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["inkoperID"] = this.inkoperID;
      data["inkoperIdentificatie"] = this.inkoperIdentificatie;
      data["wachtwoord"] = this.wachtwoord;
      data["koperNummer"] = this.koperNummer;
      data["aanmaakDatumTijd"] = this.aanmaakDatumTijd ? this.aanmaakDatumTijd.toISOString() : <any>undefined;
      data["aanmaakGebruiker"] = this.aanmaakGebruiker;
      data["blokkeerIndicatie"] = this.blokkeerIndicatie;
      data["locatieCode"] = this.locatieCode;
      data["mutatieGebruiker"] = this.mutatieGebruiker;
      data["mutatieDatumTijd"] = this.mutatieDatumTijd ? this.mutatieDatumTijd.toISOString() : <any>undefined;
      data["vervallenDatumTijd"] = this.vervallenDatumTijd ? this.vervallenDatumTijd.toISOString() : <any>undefined;
      data["isVervallen"] = this.isVervallen;
      data["zetelnummer"] = this.zetelnummer;
      data["blokkerenDatumTijd"] = this.blokkerenDatumTijd ? this.blokkerenDatumTijd.toISOString() : <any>undefined;
      data["vrijgaveDatumTijd"] = this.vrijgaveDatumTijd ? this.vrijgaveDatumTijd.toISOString() : <any>undefined;
      data["blokkeerRedenCode"] = this.blokkeerRedenCode;
      data["opmerking"] = this.opmerking;
      data["koperNaam"] = this.koperNaam;
      data["locatieOmschrijving"] = this.locatieOmschrijving;
      data["blokkeerRedenOmschrijving"] = this.blokkeerRedenOmschrijving;
      data["blokkeerRedenAutomatisch"] = this.blokkeerRedenAutomatisch;
      data["sourceCode"] = this.sourceCode;
      data["alias"] = this.alias;
      if (Array.isArray(this.inkoperPlaten)) {
          data["inkoperPlaten"] = [];
          for (let item of this.inkoperPlaten)
              data["inkoperPlaten"].push(item.toJSON());
      }
      data["inkoperPlatenLijst"] = this.inkoperPlatenLijst;
      data["inkoperLimiet"] = this.inkoperLimiet;
      data["inkoperLimietId"] = this.inkoperLimietId;
      data["limietEindDatum"] = this.limietEindDatum ? this.limietEindDatum.toISOString() : <any>undefined;
      return data;
  }

  clone(): InkoperView {
      const json = this.toJSON();
      let result = new InkoperView();
      result.init(json);
      return result;
  }
}

export interface IInkoperView {
  /** Gets or sets the InkoperID. */
  inkoperID?: number;
  /** Gets or sets the InkoperIdentificatie. */
  inkoperIdentificatie?: string | undefined;
  /** Gets or sets the Wachtwoord. */
  wachtwoord?: string | undefined;
  /** Gets or sets the KoperNummer. */
  koperNummer?: number;
  /** Gets or sets the AanmaakDatumTijd. */
  aanmaakDatumTijd?: Date;
  /** Gets or sets the AanmaakGebruiker. */
  aanmaakGebruiker?: string | undefined;
  /** Gets or sets the blokkeerindicatie. */
  blokkeerIndicatie?: boolean;
  /** Gets or sets the LocatieCode. */
  locatieCode?: string | undefined;
  /** Gets or sets the MutatieGebruiker. */
  mutatieGebruiker?: string | undefined;
  /** Gets or sets the MutatieDatumTijd. */
  mutatieDatumTijd?: Date;
  /** Gets or sets the VervallenDatumTijd. */
  vervallenDatumTijd?: Date;
  /** Is this User Account expired? */
  isVervallen?: boolean;
  /** Gets or sets the Zetelnummer. */
  zetelnummer?: number | undefined;
  /** Gets or sets the BlokkerenDatumTijd. */
  blokkerenDatumTijd?: Date | undefined;
  /** Gets or sets the VrijgaveDatumTijd. */
  vrijgaveDatumTijd?: Date | undefined;
  /** Gets or sets the BlokkeerRedenCode. */
  blokkeerRedenCode?: number | undefined;
  /** Gets or sets the Opmerking. */
  opmerking?: string | undefined;
  /** Gets or sets the KoperNaam. */
  koperNaam?: string | undefined;
  /** Gets or sets the LocatieOmschrijving. */
  locatieOmschrijving?: string | undefined;
  /** Gets or sets the BlokkeerRedenOmschrijving. */
  blokkeerRedenOmschrijving?: string | undefined;
  /** Gets or sets the BlokkeerRedenAutomatisch. */
  blokkeerRedenAutomatisch?: boolean | undefined;
  /** Gets or sets the source */
  sourceCode?: string | undefined;
  /** Gets or sets the alias */
  alias?: string | undefined;
  /** Gets or sets the InkoperPlaten. */
  inkoperPlaten?: InkoperPlaatView[] | undefined;
  /** Gets or sets InkoperPlatenLijst (t.b.v. filteren op frontend). */
  inkoperPlatenLijst?: string | undefined;
  /** de Inkoperlimiet */
  inkoperLimiet?: number | undefined;
  /** id van de inkoperlimiet */
  inkoperLimietId?: number | undefined;
  /** eind datum van de inkoperlimiet */
  limietEindDatum?: Date | undefined;
}

export class KlantLimiet implements IKlantLimiet {
  klantNummer?: number;
  klantNaam?: string | undefined;
  limiet?: number;
  ingangsdatumDatumTijd?: Date;
  eindDatumDatumTijd?: Date | undefined;
  mutatieGebruiker?: string | undefined;
  omzet?: number;

  constructor(data?: IKlantLimiet) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.klantNummer = _data["klantNummer"];
          this.klantNaam = _data["klantNaam"];
          this.limiet = _data["limiet"];
          this.ingangsdatumDatumTijd = _data["ingangsdatumDatumTijd"] ? new Date(_data["ingangsdatumDatumTijd"].toString()) : <any>undefined;
          this.eindDatumDatumTijd = _data["eindDatumDatumTijd"] ? new Date(_data["eindDatumDatumTijd"].toString()) : <any>undefined;
          this.mutatieGebruiker = _data["mutatieGebruiker"];
          this.omzet = _data["omzet"];
      }
  }

  static fromJS(data: any): KlantLimiet {
      data = typeof data === 'object' ? data : {};
      let result = new KlantLimiet();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["klantNummer"] = this.klantNummer;
      data["klantNaam"] = this.klantNaam;
      data["limiet"] = this.limiet;
      data["ingangsdatumDatumTijd"] = this.ingangsdatumDatumTijd ? this.ingangsdatumDatumTijd.toISOString() : <any>undefined;
      data["eindDatumDatumTijd"] = this.eindDatumDatumTijd ? this.eindDatumDatumTijd.toISOString() : <any>undefined;
      data["mutatieGebruiker"] = this.mutatieGebruiker;
      data["omzet"] = this.omzet;
      return data;
  }

  clone(): KlantLimiet {
      const json = this.toJSON();
      let result = new KlantLimiet();
      result.init(json);
      return result;
  }
}

export interface IKlantLimiet {
  klantNummer?: number;
  klantNaam?: string | undefined;
  limiet?: number;
  ingangsdatumDatumTijd?: Date;
  eindDatumDatumTijd?: Date | undefined;
  mutatieGebruiker?: string | undefined;
  omzet?: number;
}

/** Class Koper. */
export class Koper implements IKoper {
  /** Gets or sets the blokkeerindicatie. */
  blokkeerindicatie?: string | undefined;
  /** Gets or sets the eancode. */
  eancode?: string | undefined;
  /** Gets or sets the einddatum. */
  einddatum?: Date | undefined;
  /** Gets or sets the kopernaam. */
  kopernaam?: string | undefined;
  /** Gets or sets the kopernummer. */
  kopernummer!: number;
  /** Gets or sets the relatienummer. */
  relatienummer?: number | undefined;

  constructor(data?: IKoper) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.blokkeerindicatie = _data["blokkeerindicatie"];
          this.eancode = _data["eancode"];
          this.einddatum = _data["einddatum"] ? new Date(_data["einddatum"].toString()) : <any>undefined;
          this.kopernaam = _data["kopernaam"];
          this.kopernummer = _data["kopernummer"];
          this.relatienummer = _data["relatienummer"];
      }
  }

  static fromJS(data: any): Koper {
      data = typeof data === 'object' ? data : {};
      let result = new Koper();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["blokkeerindicatie"] = this.blokkeerindicatie;
      data["eancode"] = this.eancode;
      data["einddatum"] = this.einddatum ? this.einddatum.toISOString() : <any>undefined;
      data["kopernaam"] = this.kopernaam;
      data["kopernummer"] = this.kopernummer;
      data["relatienummer"] = this.relatienummer;
      return data;
  }

  clone(): Koper {
      const json = this.toJSON();
      let result = new Koper();
      result.init(json);
      return result;
  }
}

/** Class Koper. */
export interface IKoper {
  /** Gets or sets the blokkeerindicatie. */
  blokkeerindicatie?: string | undefined;
  /** Gets or sets the eancode. */
  eancode?: string | undefined;
  /** Gets or sets the einddatum. */
  einddatum?: Date | undefined;
  /** Gets or sets the kopernaam. */
  kopernaam?: string | undefined;
  /** Gets or sets the kopernummer. */
  kopernummer: number;
  /** Gets or sets the relatienummer. */
  relatienummer?: number | undefined;
}

export class Locatie implements ILocatie {
  locatieCode?: string | undefined;
  locatieOmschrijving?: string | undefined;

  constructor(data?: ILocatie) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.locatieCode = _data["locatieCode"];
          this.locatieOmschrijving = _data["locatieOmschrijving"];
      }
  }

  static fromJS(data: any): Locatie {
      data = typeof data === 'object' ? data : {};
      let result = new Locatie();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["locatieCode"] = this.locatieCode;
      data["locatieOmschrijving"] = this.locatieOmschrijving;
      return data;
  }

  clone(): Locatie {
      const json = this.toJSON();
      let result = new Locatie();
      result.init(json);
      return result;
  }
}

export interface ILocatie {
  locatieCode?: string | undefined;
  locatieOmschrijving?: string | undefined;
}

export class MigratieInkoper implements IMigratieInkoper {
  inkoperId?: number;
  inkoperIdentificatie?: string | undefined;
  alias?: string | undefined;

  constructor(data?: IMigratieInkoper) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.inkoperId = _data["inkoperId"];
          this.inkoperIdentificatie = _data["inkoperIdentificatie"];
          this.alias = _data["alias"];
      }
  }

  static fromJS(data: any): MigratieInkoper {
      data = typeof data === 'object' ? data : {};
      let result = new MigratieInkoper();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["inkoperId"] = this.inkoperId;
      data["inkoperIdentificatie"] = this.inkoperIdentificatie;
      data["alias"] = this.alias;
      return data;
  }

  clone(): MigratieInkoper {
      const json = this.toJSON();
      let result = new MigratieInkoper();
      result.init(json);
      return result;
  }
}

export interface IMigratieInkoper {
  inkoperId?: number;
  inkoperIdentificatie?: string | undefined;
  alias?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          for (var property in _data) {
              if (_data.hasOwnProperty(property))
                  this[property] = _data[property];
          }
          this.type = _data["type"];
          this.title = _data["title"];
          this.status = _data["status"];
          this.detail = _data["detail"];
          this.instance = _data["instance"];
      }
  }

  static fromJS(data: any): ProblemDetails {
      data = typeof data === 'object' ? data : {};
      let result = new ProblemDetails();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      for (var property in this) {
          if (this.hasOwnProperty(property))
              data[property] = this[property];
      }
      data["type"] = this.type;
      data["title"] = this.title;
      data["status"] = this.status;
      data["detail"] = this.detail;
      data["instance"] = this.instance;
      return data;
  }

  clone(): ProblemDetails {
      const json = this.toJSON();
      let result = new ProblemDetails();
      result.init(json);
      return result;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class UpdateInkoperKlokken implements IUpdateInkoperKlokken {
  inkoperKlokken?: InkoperKlokView[] | undefined;

  constructor(data?: IUpdateInkoperKlokken) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          if (Array.isArray(_data["inkoperKlokken"])) {
              this.inkoperKlokken = [] as any;
              for (let item of _data["inkoperKlokken"])
                  this.inkoperKlokken!.push(InkoperKlokView.fromJS(item));
          }
      }
  }

  static fromJS(data: any): UpdateInkoperKlokken {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateInkoperKlokken();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.inkoperKlokken)) {
          data["inkoperKlokken"] = [];
          for (let item of this.inkoperKlokken)
              data["inkoperKlokken"].push(item.toJSON());
      }
      return data;
  }

  clone(): UpdateInkoperKlokken {
      const json = this.toJSON();
      let result = new UpdateInkoperKlokken();
      result.init(json);
      return result;
  }
}

export interface IUpdateInkoperKlokken {
  inkoperKlokken?: InkoperKlokView[] | undefined;
}

/** Class UserAccountDayLimit */
export class UserAccountDayLimit implements IUserAccountDayLimit {
  /** Gets or sets the UserAccountDayLimitId */
  userAccountDayLimitId?: number;
  /** Gets or sets the UserAccountName */
  userAccountName?: string | undefined;
  /** Gets or sets the day limit */
  userAccountDayLimitAmount?: number;
  /** Gets or sets the start date */
  startDateTime?: Date;
  /** Gets or sets the end date */
  endDateTime?: Date;
  /** Gets or sets the date a limit was created on */
  creationDateTime?: Date;
  /** Gets or sets the username that created a limit */
  creationUser?: string | undefined;
  /** Get or sets the date a limit was mutated */
  mutationDateTime?: Date;
  /** Gets or sets the username that mutated a limit */
  mutationUser?: string | undefined;

  constructor(data?: IUserAccountDayLimit) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.userAccountDayLimitId = _data["userAccountDayLimitId"];
          this.userAccountName = _data["userAccountName"];
          this.userAccountDayLimitAmount = _data["userAccountDayLimitAmount"];
          this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
          this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
          this.creationDateTime = _data["creationDateTime"] ? new Date(_data["creationDateTime"].toString()) : <any>undefined;
          this.creationUser = _data["creationUser"];
          this.mutationDateTime = _data["mutationDateTime"] ? new Date(_data["mutationDateTime"].toString()) : <any>undefined;
          this.mutationUser = _data["mutationUser"];
      }
  }

  static fromJS(data: any): UserAccountDayLimit {
      data = typeof data === 'object' ? data : {};
      let result = new UserAccountDayLimit();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["userAccountDayLimitId"] = this.userAccountDayLimitId;
      data["userAccountName"] = this.userAccountName;
      data["userAccountDayLimitAmount"] = this.userAccountDayLimitAmount;
      data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
      data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
      data["creationDateTime"] = this.creationDateTime ? this.creationDateTime.toISOString() : <any>undefined;
      data["creationUser"] = this.creationUser;
      data["mutationDateTime"] = this.mutationDateTime ? this.mutationDateTime.toISOString() : <any>undefined;
      data["mutationUser"] = this.mutationUser;
      return data;
  }

  clone(): UserAccountDayLimit {
      const json = this.toJSON();
      let result = new UserAccountDayLimit();
      result.init(json);
      return result;
  }
}

/** Class UserAccountDayLimit */
export interface IUserAccountDayLimit {
  /** Gets or sets the UserAccountDayLimitId */
  userAccountDayLimitId?: number;
  /** Gets or sets the UserAccountName */
  userAccountName?: string | undefined;
  /** Gets or sets the day limit */
  userAccountDayLimitAmount?: number;
  /** Gets or sets the start date */
  startDateTime?: Date;
  /** Gets or sets the end date */
  endDateTime?: Date;
  /** Gets or sets the date a limit was created on */
  creationDateTime?: Date;
  /** Gets or sets the username that created a limit */
  creationUser?: string | undefined;
  /** Get or sets the date a limit was mutated */
  mutationDateTime?: Date;
  /** Gets or sets the username that mutated a limit */
  mutationUser?: string | undefined;
}

/** Represents a view model for user account day limits. */
export class UserAccountDayLimitView implements IUserAccountDayLimitView {
  /** Gets or sets the UserAccountDayLimitId */
  userAccountDayLimitId?: number;
  /** Gets or sets the UserAccountName */
  userAccountName?: string | undefined;
  userAccountId?: number;
  isUserAccountBlocked?: boolean;
  blockedDate?: Date | undefined;
  /** the customer's administration number */
  customerAdministrationNumber?: number;
  /** the customer name */
  customerName?: string | undefined;
  /** Gets or sets the day limit */
  userAccountDayLimitAmount?: number;
  /** Gets or sets the start date */
  startDateTime?: Date;
  /** Gets or sets the end date */
  endDateTime?: Date;
  /** Gets or sets the date a limit was created on */
  creationDateTime?: Date;
  /** Gets or sets the username that created a limit */
  creationUser?: string | undefined;
  /** Get or sets the date a limit was mutated */
  mutationDateTime?: Date;
  /** Gets or sets the username that mutated a limit */
  mutationUser?: string | undefined;

  constructor(data?: IUserAccountDayLimitView) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.userAccountDayLimitId = _data["userAccountDayLimitId"];
          this.userAccountName = _data["userAccountName"];
          this.userAccountId = _data["userAccountId"];
          this.isUserAccountBlocked = _data["isUserAccountBlocked"];
          this.blockedDate = _data["blockedDate"] ? new Date(_data["blockedDate"].toString()) : <any>undefined;
          this.customerAdministrationNumber = _data["customerAdministrationNumber"];
          this.customerName = _data["customerName"];
          this.userAccountDayLimitAmount = _data["userAccountDayLimitAmount"];
          this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
          this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
          this.creationDateTime = _data["creationDateTime"] ? new Date(_data["creationDateTime"].toString()) : <any>undefined;
          this.creationUser = _data["creationUser"];
          this.mutationDateTime = _data["mutationDateTime"] ? new Date(_data["mutationDateTime"].toString()) : <any>undefined;
          this.mutationUser = _data["mutationUser"];
      }
  }

  static fromJS(data: any): UserAccountDayLimitView {
      data = typeof data === 'object' ? data : {};
      let result = new UserAccountDayLimitView();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["userAccountDayLimitId"] = this.userAccountDayLimitId;
      data["userAccountName"] = this.userAccountName;
      data["userAccountId"] = this.userAccountId;
      data["isUserAccountBlocked"] = this.isUserAccountBlocked;
      data["blockedDate"] = this.blockedDate ? this.blockedDate.toISOString() : <any>undefined;
      data["customerAdministrationNumber"] = this.customerAdministrationNumber;
      data["customerName"] = this.customerName;
      data["userAccountDayLimitAmount"] = this.userAccountDayLimitAmount;
      data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
      data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
      data["creationDateTime"] = this.creationDateTime ? this.creationDateTime.toISOString() : <any>undefined;
      data["creationUser"] = this.creationUser;
      data["mutationDateTime"] = this.mutationDateTime ? this.mutationDateTime.toISOString() : <any>undefined;
      data["mutationUser"] = this.mutationUser;
      return data;
  }

  clone(): UserAccountDayLimitView {
      const json = this.toJSON();
      let result = new UserAccountDayLimitView();
      result.init(json);
      return result;
  }
}

/** Represents a view model for user account day limits. */
export interface IUserAccountDayLimitView {
  /** Gets or sets the UserAccountDayLimitId */
  userAccountDayLimitId?: number;
  /** Gets or sets the UserAccountName */
  userAccountName?: string | undefined;
  userAccountId?: number;
  isUserAccountBlocked?: boolean;
  blockedDate?: Date | undefined;
  /** the customer's administration number */
  customerAdministrationNumber?: number;
  /** the customer name */
  customerName?: string | undefined;
  /** Gets or sets the day limit */
  userAccountDayLimitAmount?: number;
  /** Gets or sets the start date */
  startDateTime?: Date;
  /** Gets or sets the end date */
  endDateTime?: Date;
  /** Gets or sets the date a limit was created on */
  creationDateTime?: Date;
  /** Gets or sets the username that created a limit */
  creationUser?: string | undefined;
  /** Get or sets the date a limit was mutated */
  mutationDateTime?: Date;
  /** Gets or sets the username that mutated a limit */
  mutationUser?: string | undefined;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  errors?: { [key: string]: string[]; } | undefined;

  [key: string]: any;

  constructor(data?: IValidationProblemDetails) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          for (var property in _data) {
              if (_data.hasOwnProperty(property))
                  this[property] = _data[property];
          }
          this.type = _data["type"];
          this.title = _data["title"];
          this.status = _data["status"];
          this.detail = _data["detail"];
          this.instance = _data["instance"];
          if (_data["errors"]) {
              this.errors = {} as any;
              for (let key in _data["errors"]) {
                  if (_data["errors"].hasOwnProperty(key))
                      (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
              }
          }
      }
  }

  static fromJS(data: any): ValidationProblemDetails {
      data = typeof data === 'object' ? data : {};
      let result = new ValidationProblemDetails();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      for (var property in this) {
          if (this.hasOwnProperty(property))
              data[property] = this[property];
      }
      data["type"] = this.type;
      data["title"] = this.title;
      data["status"] = this.status;
      data["detail"] = this.detail;
      data["instance"] = this.instance;
      if (this.errors) {
          data["errors"] = {};
          for (let key in this.errors) {
              if (this.errors.hasOwnProperty(key))
                  (<any>data["errors"])[key] = (<any>this.errors)[key];
          }
      }
      return data;
  }

  clone(): ValidationProblemDetails {
      const json = this.toJSON();
      let result = new ValidationProblemDetails();
      result.init(json);
      return result;
  }
}

export interface IValidationProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  errors?: { [key: string]: string[]; } | undefined;

  [key: string]: any;
}

/** Enum Vestiging */
export enum Vestiging {
  Aalsmeer = "aalsmeer",
  Naaldwijk = "naaldwijk",
  Rijnsburg = "rijnsburg",
  Eelde = "eelde",
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
      super();

      this.message = message;
      this.status = status;
      this.response = response;
      this.headers = headers;
      this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
      return obj.isApiException === true;
  }
}

export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
  if (result !== null && result !== undefined)
    throw result;
  else
    throw new ApiException(message, status, response, headers, null);
}
